var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodUploadModelCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.66699V2.83366M3.5 1.66699V2.83366",
    stroke: "#414E5D",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99868 8.08301H7.00393M6.99868 10.4163H7.00393M9.32939 8.08301H9.33464M4.66797 8.08301H4.6732M4.66797 10.4163H4.6732",
    stroke: "#414E5D",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04297 5.16699H11.9596",
    stroke: "#414E5D",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45703 7.64187C1.45703 5.10013 1.45703 3.82925 2.18743 3.03962C2.91784 2.25 4.0934 2.25 6.44453 2.25H7.55286C9.90399 2.25 11.0796 2.25 11.81 3.03962C12.5404 3.82925 12.5404 5.10013 12.5404 7.64187V7.94147C12.5404 10.4832 12.5404 11.7541 11.81 12.5437C11.0796 13.3333 9.90399 13.3333 7.55286 13.3333H6.44453C4.0934 13.3333 2.91784 13.3333 2.18743 12.5437C1.45703 11.7541 1.45703 10.4832 1.45703 7.94147V7.64187Z",
    stroke: "#414E5D",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 5.16699H12.25",
    stroke: "#414E5D",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodUploadModelCalender);
export default __webpack_public_path__ + "static/media/pod-upload-model-calender.c85abf54ab2d3fa2195bd64ae8b1da09.svg";
export { ForwardRef as ReactComponent };